import { render } from "./artist.vue?vue&type=template&id=7b40e616&scoped=true"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"

import "./artist.vue?vue&type=style&index=0&id=7b40e616&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b40e616"]])

export default __exports__